module.exports = __webpack_public_path__ + "img/check-approve-img.e7ba7abc.png";